import {
  LLT_PENDING,
  LLT_FAILED,
  LLT_DOWNLOADED,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LLT_PENDING:
      return {
        ...state,
        pending: true
      };
    case LLT_FAILED:
      return {
        ...state,
        pending: false,
        error: action.payload
      };
    case LLT_DOWNLOADED:
      return {
        ...state,
        pending: false,
        content: action.payload,
        error: INITIAL_STATE.error
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/longLocationDurations/reducers.js